import { PUBLIC_PAM_CLIENT_API_URL } from '@/app/_constants/urls'

export const ACTIVATED_LOCATION_KEY = 'activated-location'
export const USER_TOKEN_KEY = 'x-tut'
export const LOGIN_PAGE_BASE_PATH = `${PUBLIC_PAM_CLIENT_API_URL}/accounts/login`
